import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var SfIconSvg = function SfIconSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.536 9.403 13.474.851 12 0 8.536 6 6.805 3l-.17.098-1.305.754zM12.517 7.702h9.876V6h-6.93l1.734-3-.17-.097-1.304-.754zM8.02 13.702H1.607v-1.701h3.464l-3.464-6 1.475-.851zM15.98 10.3h6.413V12h-3.464l3.464 6-1.475.851zM11.483 16.298l-3.206 5.553-1.305-.754-.167-.096 1.731-3H1.607v-1.703zM15.464 14.597l3.206 5.553-1.305.754-.17.097-1.731-3L12 24l-1.474-.85.213-.368z"
  }));
};
export var SfIcon = function SfIcon(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: SfIconSvg
  }));
};